import React, { Component } from 'react';
import '../css/App.css';
import '../css/rwdLimit.css';
import { observer } from 'mobx-react';
import Appbar from './Appbar'
import DonateForm from './DonateForm/DonateForm'
import Result from './Result/Result'
import {Route, Switch} from 'react-router';
import {HashRouter} from 'react-router-dom'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import lightBlue from '@material-ui/core/colors/lightBlue';
import pink from '@material-ui/core/colors/pink';
import { withRouter } from "react-router";
const theme = createMuiTheme({
  palette: {
    primary: lightBlue,
    secondary: pink,
  },
  typography: {
    useNextVariants: true,
    color: '#333',
    fontFamily: 'Noto Sans TC, sans-serif'
  },
});

class App extends Component {
  render() {
    let strUrl = window.location.href;
    let getPara, ParaVal;
    let aryPara = [];    
    
    if (strUrl.indexOf("?") != -1) {
      let getSearch = strUrl.split("?");
      getPara = getSearch[1].split("&");
      for (let i = 0; i < getPara.length; i++) {
        ParaVal = getPara[i].split("=");        
        aryPara.push(ParaVal[0]);
        aryPara[ParaVal[0]] = ParaVal[1];
        
      }     
    }
    return (
      <div className="App">   
      <MuiThemeProvider theme={theme}>
      {aryPara.app === 'true' ? null :<Appbar/>}
        <HashRouter>
          <Switch>            
            <Route exact path="/" component={DonateForm}/> 
            <Route exact path="/result" component={Result}/>                             
          </Switch>
        </HashRouter>
      </MuiThemeProvider>   
      </div>
    );
  }
}

export default observer(App);
